import React, { FC } from "react";
import useTranslate from "../../../modules/core/languages/hooks/useTranslate";
import {BookingCom} from "../../../modules/hotels/components/icons/BookingCom";
import NcModal from "../../../modules/ui/shared/NcModal/NcModal";
import ButtonSecondary from "../../../modules/ui/shared/Button/ButtonSecondary";
import ButtonPrimary from "../../../modules/ui/shared/Button/ButtonPrimary";

export interface HotelRedirectModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const HotelRedirectModal: FC<HotelRedirectModalProps> = ({
    isOpen,
    onClose,
    onConfirm
}) => {
    const t = useTranslate();

    const modalContent = (
        <div className="text-center">
            <div className="mb-6 flex justify-center">
                <BookingCom size={150} />
            </div>
            <p className="text-neutral-600 dark:text-neutral-300 mb-6 text-lg">
                {t('hotelMapCard.externalRedirectMessage')}
            </p>
            <div className="flex justify-between pt-4 gap-3">
                <ButtonSecondary onClick={onClose}>
                    {t('hotelMapCard.cancel')}
                </ButtonSecondary>
                <ButtonPrimary onClick={onConfirm}>
                    {t('hotelMapCard.ok')}
                </ButtonPrimary>
            </div>
        </div>
    );

    return (
        <NcModal
            contentExtraClass="max-w-screen-sm"
            modalTitle={t('hotelMapCard.externalRedirectTitle')}
            renderContent={() => modalContent}
            renderTrigger={() => null}
            isOpenProp={isOpen}
            onCloseModal={onClose}
        />
    );
};

export default HotelRedirectModal;
